import veritoneApi from './veritoneApi';
import momentTz from 'moment-timezone';
import { get } from 'lodash';
import { mockFailData, mockSuccessData } from '../../test/saga_mock_data/advertiserSaga'
import { TRACKING_SOURCE_NAME } from './constant';

function genAdvertiserLogoQuery(TDOId) {
    return `{
        temporalDataObject(id: ${TDOId}){
          assets{
            records {
              id
              signedUri
              uri
            }
          }
        }
      }`;
};
    
export function loadMediaContentApi(urlApi, TDOId) {
    return veritoneApi(urlApi.graphql)
    .post(
        '',
        { query: genAdvertiserLogoQuery(TDOId) }
    )
    .then(response => get(
        response,
        'data.data.temporalDataObject.assets.records[0].signedUri',
        null
        )
    )
    .catch(error => ({
        error: true,
        ...error
    }))
}

export function getAdvertiserApi(urlApi, id) {
    return veritoneApi(urlApi.baseUrl)
        .get(`${urlApi.advertiser}/${id}`)
        .then(response => response.data.advertiser)
        .catch(error => ({
            error: true,
            ...error
        }))
}

export function removeAdvertiserApi(urlApi, id) {
    return veritoneApi(urlApi.baseUrl)
        .delete(`${urlApi.advertiser}/${id}`)
        .then(response => response)
        .catch(error => ({
            error: true,
            ...error
        }))
}

export function addAdvertiserApi(urlApi, advertiser) {
    return veritoneApi(urlApi.baseUrl)
        .post(
            `${urlApi.advertiser}/`,
            advertiser
        )
        .then(response => response.data.advertiser)
        .catch(error => ({
            error: true,
            ...error
        }))
}
export function sendInviteApi(urlApi, data) {
    const body = {
        "invite_recipient_emails": data.emails,
        "invite_message": data.message && Object.keys(data.message).length === 0 ? "" : data.message,
        "invite_created_email": data.inviteCreatedEmail,
        "invite_template": data.template,
    };

    if (data.isPixelAdvertiser) {
        body["pixel_id"] = data.pixelId;
    };
    return veritoneApi(urlApi.baseUrl)
        .post(
            `${urlApi.advertiser}/${data.advertiserId}/invite`,
            body
        )
        .then(response => response)
        .catch(error => ({
            error: true,
            ...error
        }))
}

export function dismissInviteApi(urlApi, data) {
    const body = {
        'is_show_connection_notice': data.isShowConnectionNotice
    };
    return veritoneApi(urlApi.baseUrl)
    .post(`${urlApi.advertiser}/${data.advertiserId}/connectionNoticeStatus`,
    body)
    .then(response => response)
    .catch(error => ({
        error: true,
        ...error
    }))
}

export function updateAdvertiserApi(urlApi, advertiser) {
    return veritoneApi(urlApi.baseUrl)
        .put(
            `${urlApi.advertiser}/${advertiser.advertiser_id}`,
            advertiser
        )
        .then(response => {
            return (
                response.data.advertiser
            )
        })
        .catch(error => ({
            error: true,
            ...error
        }))
}

// TODO: Ask Dat if we are still using this API.
export function getCalendarDataApi(urlApi, advertiser_id) {
    const timeZone = momentTz.tz.guess()
    return veritoneApi(urlApi.baseUrl)
        .get(
            `${urlApi.advertiser}/${advertiser_id}/calendar?timeZone=${timeZone}`
        )
        .then(response => {
            return response.data.data
        })
        .catch(error => ({
            error: true,
            ...error
        }))
}


export async function loadAdvertisersApi(urlApi, type = 'self') {
    try {
        const response = await veritoneApi(urlApi.baseUrl)
            .get(`/get_advertiser/${type}`);
        const data =  response.data;
        return data;
    } catch (error) {
        return ({
            error: true,
            ...error
        });
    }
}

export async function loadAdvertisersTeamApi(urlApi, limit = 1000) {
    let allData = [];
    let offset = 0;
    let isLastPage = false;
    let fetchedTeamResults = {};
  
    while (isLastPage === false) {
      try {
        const response = await veritoneApi(urlApi.baseUrl)
          .get(`/get_advertiser/team?limit=${limit}&offset=${offset}`);
  
        fetchedTeamResults = get(response, 'data', {});
        isLastPage = get(fetchedTeamResults, 'isLastPage');
        offset += get(fetchedTeamResults, 'limit', 0); // Update offset for next request
  
        // Append fetched data to the accumulator
        allData = [...allData, ...get(fetchedTeamResults, 'data', [])];
      } catch (error) {
        console.error("Error fetching advertiser data:", error); 
        return { 
          error: true,
          message: "Failed to fetch advertiser data. Please try again later.",
          details: error 
        };
      }
    }
  
    return { ...fetchedTeamResults, data: allData }; 
}

export function updateAdvertiserPermissionsApi(urlApi, advertiserId, selectedUsers) {
    return veritoneApi(urlApi.baseUrl)
        .post(
            `${urlApi.advertiser}/${advertiserId}/share`,
            selectedUsers
        )
        .then(response => {
            return response.data.data
        })
        .catch(error => ({
            error: true,
            ...error
        }))
}

export function checkAdvertiserGaConnectionApi(urlApi, advertiserId) {
    return veritoneApi(urlApi.baseUrl)
        .get(
            `${urlApi.advertiser}/check_ga_connection/${advertiserId}`
        )
        .then(response => {
            return response.data;
        })
        .catch(error => ({
            resError: true,//use resError to not misunderstood with data.error (Google Error) from success API response
            ...error
        }))
}

export function getWeblogFilesByAdvertiserApi(urlApi, advertiserIds) {
    const paramsString = advertiserIds.map(id => 'advertisers[]=' + id).join('&');

    return veritoneApi(urlApi.baseUrl)
    .get(
        `${urlApi.advertiser}/uploader/web_logs?${paramsString}`
    )
    .then(response => {
        return response.data.data;
    })
    .catch(error => ({
        error: true,
        ...error
    }))
}

export function ga4InviteToConnectApi(urlApi, advertiser = {}){
    const {
        advertiserId,
        inviteMessage,
        inviteRecipientEmails = []
    } = advertiser;
    return veritoneApi(urlApi.baseUrl)
        .post(
            `${urlApi.advertiser}/${advertiserId}/ga4_invitation`,
            {
                inviteMessage,
                inviteRecipientEmails,
            }
        )
        .then(response => {return response.data})
        .catch(error => ({
            error: true,
            ...error
        }
    ))
}

export function sendAlertForAdvertiserConnection(
  urlApi,
  advertiserId,
  recipientEmails,
  message
) {
  return veritoneApi(urlApi.baseUrl)
    .post(`${urlApi.advertiser}/${advertiserId}/send_connection_alert`, {
        recipientEmails,
        message
    })
    .then(response => {
      return response.data;
    })
    .catch(error => ({
      error: true,
      ...error
    }));
}

export function updateCutoverDateApi(urlApi, advertiserId, newDate) {
    const body = {
        'cutoverDate': newDate
    };
    return veritoneApi(urlApi.baseUrl)
    .post(
        `${urlApi.advertiser}/${advertiserId}/google_analytics_cutover_date`,
        body
    )
    .then(response => {
        return response.data.data;
    })
    .catch(error => ({
        error: true,
        ...error
    }))
}

export function deleteGA4ConnectionApi(urlApi, advertiserId) {
    return veritoneApi(urlApi.baseUrl)
        .put(`${urlApi.advertiser}/${advertiserId}/google_analytics_4/reset_connection`)
        .then(response => {
            return response.data;
        })
        .catch(error => ({
            error: true,
            ...error
        }))
}

export function getListPixelApi(urlApi, pixelIds) {
    return veritoneApi(urlApi.baseUrl)
    .post('/pixel/list', pixelIds)
    .then(response => {
        return response.data;
    })
    .catch(error => ({
        error: true,
        ...error
    }))
}

export function getIndustriesApi(urlApi) {
  return veritoneApi(urlApi.baseUrl)
    .get('/industries')
    .then((response) => response.data)
    .catch((error) => ({
      error: true,
      ...error,
    }));
}

export function getCategoriesApi(urlApi, industryId) {
  return veritoneApi(urlApi.baseUrl)
    .get(`/industries/${industryId}`)
    .then((response) => response.data)
    .catch((error) => ({
      error: true,
      ...error,
    }));
}
export function updatePixelAdvertiserApi(urlApi, pixel) {
    const { pixelId, ...restPixel } = pixel || {};
    return veritoneApi(urlApi.baseUrl)
        .put(`/pixel/${pixelId}`, restPixel)
        .then((response) => {
            return response.data.pixel;
        })
        .catch((error) => ({
            error: true,
            ...error,
        }));
};

export function createNewPixelApi(urlApi, data) {
    return veritoneApi(urlApi.baseUrl)
    .post('/pixel', data)
    .then(response => {
        return response.data;
    })
    .catch(error => ({
        error: true,
        ...error
    }))
}

export function getEmailTemplateApi(urlApi) {
    return veritoneApi(urlApi.baseUrl)
      .get('/form_templates')
      .then((response) => response.data)
      .catch((error) => ({
        error: true,
        ...error,
      }));
  }